import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Avatar } from "@faire/web--source/slate/Avatar";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
import styled, { css } from "styled-components";
var MAX_AVATAR_COUNT = 3;
export var TeamMemberUserInfo = function(param) {
    var className = param.className, images = param.images, title = param.title, subtitle = param.subtitle, size = param.size, maxTextWidth = param.maxTextWidth, spacingAboveTitle = param.spacingAboveTitle, avatarPileOffset = param.avatarPileOffset, onClick = param.onClick;
    var avatarPileLeftMargin = avatarPileOffset ? -avatarPileOffset : -48;
    return /*#__PURE__*/ _jsxs(UserDataWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ _jsx(Row, {
                children: images.slice(0, MAX_AVATAR_COUNT).reverse().map(function(image, index) {
                    return /*#__PURE__*/ _jsx(AvatarWrapper, {
                        $marginLeft: index === 0 ? 0 : avatarPileLeftMargin,
                        $showPointerOnHover: !!onClick,
                        onClick: onClick,
                        children: /*#__PURE__*/ _jsx(TeamMemberAvatar, {
                            $hasBorder: images.length > 1,
                            size: size !== null && size !== void 0 ? size : "large",
                            image: typeof image === "string" ? IImage.build({
                                url: image
                            }) : image
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: spacingAboveTitle !== null && spacingAboveTitle !== void 0 ? spacingAboveTitle : "1x"
            }),
            /*#__PURE__*/ _jsxs(TextWrapper, {
                $maxWidth: maxTextWidth !== null && maxTextWidth !== void 0 ? maxTextWidth : 100,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        align: "center",
                        variant: "paragraphSansMedium",
                        maxLines: 3,
                        children: title
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        align: "center",
                        maxLines: 3,
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var UserDataWrapper = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-bd948b04-0"
})([
    "flex:1;"
]);
var AvatarWrapper = styled.div.withConfig({
    componentId: "sc-bd948b04-1"
})([
    "margin-left:",
    "px;",
    ""
], function(param) {
    var $marginLeft = param.$marginLeft;
    return $marginLeft;
}, function(param) {
    var pointerOnHover = param.$showPointerOnHover;
    return pointerOnHover && css([
        "&:hover{cursor:pointer;}"
    ]);
});
var TextWrapper = styled.div.withConfig({
    componentId: "sc-bd948b04-2"
})([
    "max-width:",
    "px;word-break:break-word;"
], function(param) {
    var $maxWidth = param.$maxWidth;
    return $maxWidth;
});
var TeamMemberAvatar = styled(Avatar).withConfig({
    componentId: "sc-bd948b04-3"
})([
    "",
    ""
], function(props) {
    return props.$hasBorder ? css([
        "border-left:1px solid ",
        ";border-bottom:1px solid ",
        ";border-top:1px solid ",
        ";"
    ], Core.surface.subdued, Core.surface.subdued, Core.surface.subdued) : "";
});
